<template>
  <div>
    <h4>Selected Jobs</h4>
    <hr />
    <draggable :list="items" class="list-group run-item" @end="updateSortOrder">
      <div
        class="run-item list-group-item"
        :key="index"
        v-for="(item, index) in value"
      >
        <div class="run-item-handle">
          <i class="material-icons">drag_handle</i>
        </div>
        <div class="run-item-body">
          <selected-job-summary :job="job(item)"></selected-job-summary>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import SelectedJobSummary from '@/components/Modules/Run/Form/SelectedJobSummary.vue';

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    jobs: {
      type: Array,
      required: true
    }
  },

  components: {
    SelectedJobSummary,
    draggable
  },

  computed: {
    items: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    job(item) {
      return this.jobs.find(j => j.id == item.job_id);
    },

    updateSortOrder() {
      this.items = this.items.map((value, index) => ({
        ...value,
        sort_order: index
      }));
    }
  }
};
</script>

<style lang="scss">
.list-group {
  .run-item {
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    align-items: center;

    .run-item-handle {
      padding: 15px;
      border-right: 1px solid #e6e6e6;
      flex-grow: 0;
    }

    .run-item-body {
      padding: 15px;
      flex-grow: 1;
    }
  }
}
</style>
